export const estimate_statuses = {
    draft: {
        label: 'Brouillon',
        textColor: 'text-gray-500',
        badgeColor: 'gray',
    },
    sent: {
        label: 'Envoyé',
        textColor: 'text-gray-500',
        badgeColor: 'gray',
    },
    accepted: {
        label: 'Accepté',
        textColor: 'text-yellow-500',
        badgeColor: 'yellow',
    },
    refused: {
        label: 'Refusé',
        textColor: 'text-red-500',
        badgeColor: 'red',
    },
    expired: {
        label: 'Expirée',
        textColor: 'text-red-500',
        badgeColor: 'red',
    },
    cancelled: {
        label: 'Annulé',
        textColor: 'text-red-500',
        badgeColor: 'red',
    },
    read: {
        label: 'Lu',
        textColor: 'text-orange-500',
        badgeColor: 'orange',
    },
    advanced: {
        label: 'Avancé',
        textColor: 'text-green-500',
        badgeColor: 'green',
    },
    partialinvoiced: {
        label: 'Partiellement facturé',
        textColor: 'text-orange-500',
        badgeColor: 'orange',
    },
    invoiced: {
        label: 'Facturé',
        textColor: 'text-green-500',
        badgeColor: 'green',
    },
}

export const estimate_fulfillment_statuses = {
    partially_fulfilled: {
        label: 'Partiellement préparé',
        textColor: 'text-orange-500',
        badgeColor: 'orange',
    },
    pending: {
        label: 'Préparation demandée',
        textColor: 'text-orange-500',
        badgeColor: 'orange',
    },
    fulfilled: {
        label: 'Expédié',
        textColor: 'text-green-500',
        badgeColor: 'green',
    },
    not_fulfilled: {
        label: 'Non expédié',
        textColor: 'text-gray-500',
        badgeColor: 'gray',
    },
}

export const invoice_statuses = {
    draft: {
        label: 'Brouillon',
        textColor: 'text-gray-500',
        badgeColor: 'gray',
    },
    due: {
        label: 'Dûe',
        textColor: 'text-red-500',
        badgeColor: 'red',
    },
    paid: {
        label: 'Payée',
        textColor: 'text-green-500',
        badgeColor: 'green',
    },
    late: {
        label: 'Paiement en retard',
        textColor: 'text-red-500',
        badgeColor: 'red',
    },
    cancelled: {
        label: 'Annulée',
        textColor: 'text-gray-500',
        badgeColor: 'gray',
    },
}

const unknown = {
    label: 'Inconnu',
    textColor: 'text-gray-500',
    badgeColor: 'gray',
}

export function getEstimateStatus(status) {
    return estimate_statuses[status] ?? unknown
}

export function getEstimateFulfillmentStatus(status) {
    return estimate_fulfillment_statuses[status] ?? unknown
}

export function getInvoiceStatus(status) {
    return invoice_statuses[status] ?? unknown
}
